import { CalendarMonthOutlined } from "@mui/icons-material";
import dayjs from "dayjs";
import { RouteDeviationAlert } from "../resources/Api/routeApi";
import NotificationCard from "./NotificationCard";

const RouteDeviationAlertCard = ({ alert }: { alert: RouteDeviationAlert }) => (
    <NotificationCard
        category="ROTA"
        severity="CRÍTICO"
        severityColor="error"
        title="Desvio de rota confirmado"
        subject={`${alert.vehicleName} - ${alert.vehiclePlate}`}
        message={`Rota ${alert.routeName}: ${alert.outsidePoints} posições fora do corredor (${alert.longestOutsideSequence} consecutivas). Consulte o relatório de rotas para comparar os trajetos.`}
        details={[{
            key: "service-date",
            icon: <CalendarMonthOutlined fontSize="small" color="action" />,
            text: `Turno: ${dayjs(alert.serviceDate).format("DD/MM/YYYY")}`,
        }]}
    />
);

export default RouteDeviationAlertCard;
